import React from 'react';

import createHeartComponent from '@finn-no/favorite-heart-component';
import {
  BapSearchAd,
  AdImage
} from '@schibsted-nmp/search-frontend-components/react';

export type SimpleBapSearchAdProps = {
  layout?: 'grid' | 'list';
  onClick?: () => void;
};

type LabelRenderProps = {
  className?: string;
  classes: {
    badge: string;
    info: string;
    warning: string;
    success: string;
    [key: string]: string;
  };
};

export function SponsoredListingAd({
  layout = 'grid',
  onClick
}: SimpleBapSearchAdProps) {
  const mockAd = {
    ad_id: 'martailer-placeholder-001',
    canonical_url: '#',
    distance: null,
    extras: [],
    flags: [],
    heading: 'Hellkite Tyrant - FOIL (Gatecrash, GTC)',
    image: {
      aspect_ratio: 1.3333333333333333,
      height: 533,
      url: 'https://gatherer-static.wizards.com/Cards/medium/3DC259F73D4045DE1A6DF18D1AA2F28173FB5FEDD7C0AFFF6C3891FAE4769267.webp',
      width: 400
    },
    labels: [
      {
        id: 'paid_position',
        label: 'Paid Position',
        type: 'PRIMARY'
      }
    ],
    location: 'Stockholm',
    main_search_key: 'SEARCH_ID_BAP_COMMON',
    organisation_name: "Dragon's Lair",
    price: {
      currency_code: 'SEK',
      amount: 525.25,
      price_unit: 'kr'
    },
    timestamp: 1234567890,
    trade_type: 1
  };

  const IMAGE_SIZES =
    '(min-width: 1300px) 306px, (min-width: 1010px) 316px, (min-width: 768px) 33vw, (min-width: 480px) 50vw, 100vw';

  const Heart = createHeartComponent({
    userId: '12345',
    baseUri: '',
    redirectUrl: ''
  });

  return (
    <BapSearchAd
      ad={mockAd}
      currentTime={Date.now()}
      favorite={() => (
        <Heart
          variant={layout === 'grid' ? 'heart-on-image' : 'heart'}
          itemId={parseInt(mockAd.ad_id.split('-').pop() || '0', 10)}
          itemType="Ad"
          buttonClass=""
          locale="sv"
          isMobile={false}
        />
      )}
      id={mockAd.ad_id}
      imageSizes={IMAGE_SIZES}
      label={(props: LabelRenderProps) => (
        <span
          className={`${props.className} ${props.classes.badge} ${props.classes.info}`}
        >
          Paid Position
        </span>
      )}
      layout={layout}
      onClick={onClick}
      url={mockAd.canonical_url}
      image={
        layout === 'grid'
          ? () => (
              <AdImage
                aspectClass="aspect-3/4"
                height={mockAd.image.height}
                width={mockAd.image.width}
                url={mockAd.image.url}
                crop={true}
                sizes={IMAGE_SIZES}
              />
            )
          : undefined
      }
    />
  );
}
